// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__WGUoN","right":"styles_right__1JtaP"};